import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { GeneralConfirmationModalData, GeneralConfirmationModalResult } from "../../models";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'cpf-general-confirmation-modal',
  templateUrl: './general-confirmation-modal.component.html',
  styleUrls: ['./general-confirmation-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class GeneralConfirmationModalComponent {
  public GeneralConfirmationModalResult = GeneralConfirmationModalResult;

  constructor(public dialogRef: MatDialogRef<GeneralConfirmationModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: GeneralConfirmationModalData,
              private translate: TranslateService
  ) {
    if (!this.data.textAlign) {
      this.data.textAlign = 'center';
    }

    this.translateConfirmButton();
  }

  translateConfirmButton() {
    if (this.data.confirmButtonText && this.data.confirmButtonText !== 'OK' && this.data.confirmButtonText !== 'CONFIRM') {
      return;
    }

    let key = 'general-confirmation-modal.modal-footer.confirm-button';

    if (this.data.confirmButtonText === 'OK') {
      key = 'general-confirmation-modal.modal-footer.ok-button';
    }

    this.translate.get(key).subscribe((res: string) => {
      this.data.confirmButtonText = res;
    })
  }

  close(result: GeneralConfirmationModalResult) {
    this.dialogRef.close(result);
  }
}
